import {
  Box,
  Typography,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { buttonMarginSpace, buttonWidth } from '../../constants/form';
import { Routes } from '../../../../util/constants';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from '../../../../state';
import { closeModal } from '../../../../state/purchaseOrderPopupModalSlice';
import { useTranslation } from 'react-i18next';
import { openPurchaseOrderModal } from '../../../../state/purchaseOrderModalSlice';
import { popupFormWidth } from './constants';
import DraggablePaper from '../../DraggablePaper';

export default function CreatePurchaseOrderPopupModal() {
  const { t: tGlobal } = useTranslation([], {
    keyPrefix: 'team.Global.Buttons',
  });
  const { t: tCreateC } = useTranslation([], {
    keyPrefix:
      'team.Modals.Purchase Orders.createAndEdit.Create Purchase Order',
  });

  const { openPurchaseOrderPopupModal } = useSelector(
    ({ purchaseOrderPopupModalSlice }) => purchaseOrderPopupModalSlice,
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(closeModal());
  };

  const handleOpenCreatePurchaseOrderPopupModal = () => {
    handleClose();
    dispatch(openPurchaseOrderModal({ resetState: true }));
  };

  return (
    <Dialog
      open={openPurchaseOrderPopupModal}
      onClose={(event, reason) => {
        if (reason && reason === 'backdropClick') return;
        handleClose();
      }}
      maxWidth="lg"
      scroll="paper"
      PaperProps={{ style: { width: popupFormWidth } }}
      PaperComponent={DraggablePaper}
    >
      <>
        <DialogTitle
          id="draggable-dialog-title"
          sx={{ m: 0, p: 1, cursor: 'move' }}
        >
          {tCreateC('Create Purchase Order')}
        </DialogTitle>
        <IconButton
          color="primary"
          sx={{ position: 'absolute', right: 4, top: 4 }}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers sx={{ p: 1 }}>
          <Typography align="center">
            {tCreateC(
              'To avoid duplicate, it is suggested to search for existing purchase orders.',
            )}
          </Typography>
          <Typography align="center">
            {tCreateC('Search for existing purchase orders?')}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Box width="100%" sx={{ display: 'flex', justifyContent: 'end' }}>
            <Button
              variant="outlined"
              color="primary"
              sx={{ width: buttonWidth, marginRight: buttonMarginSpace }}
              onClick={handleClose}
            >
              {tGlobal('Cancel')}
            </Button>
            <Box>
              <Button
                variant="outlined"
                color="primary"
                sx={{ width: buttonWidth, marginRight: buttonMarginSpace }}
                onClick={() => {
                  navigate(Routes.HOME_ORDERS);
                  handleClose();
                }}
              >
                {tGlobal('Search')}
              </Button>
              <Button
                variant="contained"
                color="primary"
                sx={{ width: buttonWidth }}
                onClick={() => {
                  handleOpenCreatePurchaseOrderPopupModal();
                }}
              >
                {tGlobal('Create')}
              </Button>
            </Box>
          </Box>
        </DialogActions>
      </>
    </Dialog>
  );
}
